module.exports = __webpack_public_path__ + "img/assets/icons/bot.svg?76f98ee4ea6a1b6c2ebf0a44f6c53b8f";